import { useState } from "react";
import api from "../lib/api";
import { Mail, CheckCircle2, Loader2 } from "lucide-react";

/**
 * Friendly out-of-area block + email capture.
 * Shown when customer enters a non-CA shipping state.
 */
export default function WaitlistCard({ email: initialEmail = "", state = "", zip = "" }) {
  const [email, setEmail] = useState(initialEmail);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    if (!email || busy) return;
    setBusy(true);
    try {
      await api.post("/waitlist", { email, state, zip_code: zip });
      setDone(true);
    } catch {
      // best-effort silent
      setDone(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      data-testid="waitlist-card"
      className="rounded-2xl p-5 border-2 mt-3"
      style={{ background: "#fffbeb", borderColor: "#fde68a" }}
    >
      <p className="text-base font-bold text-amber-900">
        We currently only serve California
      </p>
      <p className="text-sm text-amber-900 mt-1">
        Drop your email and we&apos;ll let you know the moment we expand to your area.
      </p>
      {done ? (
        <div className="flex items-center gap-2 mt-3 text-sm font-semibold text-green-800" data-testid="waitlist-done">
          <CheckCircle2 className="w-4 h-4" /> You&apos;re on the list!
        </div>
      ) : (
        <div className="flex gap-2 mt-3">
          <div className="relative flex-1">
            <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-amber-700" />
            <input
              data-testid="waitlist-email"
              type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="w-full rounded-full border-2 border-amber-300 bg-white pl-9 pr-3 py-2 text-sm focus:border-amber-500 focus:outline-none"
            />
          </div>
          <button
            data-testid="waitlist-submit"
            onClick={submit}
            disabled={!email || busy}
            className="px-4 py-2 rounded-full bg-amber-700 text-white text-sm font-semibold disabled:opacity-50"
          >
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Notify me"}
          </button>
        </div>
      )}
    </div>
  );
}
